<div class="container">
    <div class="text-center">
        <h1 class="fs-3 fw-bold" style="color: #8E0E00;">Revenue Dashboard</h1>
    </div>

    <div class="row">
        <!-- Dropdowns Container -->
        <div class="card shadow p-3 col-12 mt-2 pb-0 cardRadius">
            <div class="row g-2">
                <!-- City Dropdown -->
                <div class="col-lg-4 col-sm-6">
                    <div class="custom-dropdown">
                        <label for="typeOfUser" class="form-label">Select City</label>
                        <select (change)="onCityChange($event)" class="form-select">
                            <option value="">All</option>
                            <option *ngFor="let city of cityList" [value]="city.id">{{ city.cityName }}</option>
                        </select>
                    </div>
                </div>

                <!-- Zone Dropdown -->
                <div class="col-lg-4 col-sm-6">
                    <div class="custom-dropdown">
                        <label for="typeOfUser" class="form-label">Select Zone</label>
                        <select (change)="onZoneChange($event)" class="form-select custom-select">
                            <option value="">All</option>
                            <option *ngFor="let zone of zoneList" [value]="zone.zoneId">{{ zone.zoneName }}</option>
                        </select>
                    </div>
                </div>

                <!-- Year Dropdown -->
                <div class="col-lg-4 col-sm-6">
                    <div class="custom-dropdown">
                        <label for="typeOfUser" class="form-label">Select Year</label>
                        <select (change)="onYearChange($event)" class="form-select">
                            <option value="">All</option>
                            <option *ngFor="let year of years" [value]="year">{{ year }}</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="d-flex justify-content-center mt-2">
                <div class="d-flex gap-2 align-items-center">
                    <h2 class="mb-0">SAR received from the requestor:</h2>
                    <h2 class="mb-0">
                        <strong>
                            {{
                            cardChartFilterData?.totalsarReceivedFromReq ??
                            revenueData?.totalsarReceivedFromReq ??
                            0
                            }}
                        </strong>
                    </h2>
                </div>
            </div>
        </div>
    </div>


    <!-- Amount allocated to dumpster and dumpyard -->

    <div class="row">
        <div class="col-lg-10 col-md-8 col-sm-12">
            <div class="card shadow mt-3 cardRadius p-2">
                <div class="custom-modal-header">
                    <h1 class="text-start fs-5 ms-2 mt-2">Amount allocated</h1>
                </div>
                <apx-chart [series]="chartSeries" [chart]="chartOptions.chart" [xaxis]="chartOptions.xaxis"
                    [yaxis]="chartOptions.yaxis" [legend]="chartOptions.legend" [colors]="chartOptions.colors"
                    [plotOptions]="chartOptions.plotOptions" [dataLabels]="chartOptions.dataLabels">
                </apx-chart>
            </div>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12">
            <div class="card shadow cardRadius p-3 mt-3">
                <h1 class="text-center fs-5" style="color: #008FFB;">
                    <strong>SAR {{
                        cardChartFilterData?.totalsarAllocatedToDumpster ??
                        revenueData?.totalsarAllocatedToDumpster ??
                        0
                        }}</strong>
                </h1>
                <p class="text-center">allocated to the Dumpster</p>
            </div>
            <div class="card shadow cardRadius p-3 mt-3">
                <h1 class="text-center fs-5" style="color: #FF4560;">
                    <strong>SAR {{
                        cardChartFilterData?.totalsarAllocatedToDumpyard ??
                        revenueData?.totalsarAllocatedToDumpyard ??
                        0
                        }}</strong>
                </h1>
                <p class="text-center">allocated to the Dump Yard</p>
            </div>
            <div class="card shadow cardRadius p-3 mt-3">
                <h1 class="text-center fs-5" style="color: #7fb519;">
                    <strong>{{
                        cardChartFilterData?.totalsarAllocatedToSmartsort ??
                        revenueData?.totalsarAllocatedToSmartsort ??
                        0
                        }}</strong>
                </h1>
                <p class="text-center">SAR allocated to the Smart-sort</p>
            </div>
        </div>
    </div>

    <!-- Amount allocated to smart-sort -->
</div>

<div class="card p-3 mt-3" *ngIf="isTableVisible">
    <!-- From Date -->
    <div class="row g-3 ms-auto">
        <!-- From Date -->
        <div class="col-auto d-flex align-items-center">
            <label for="fromDate" class="form-label me-2 text-nowrap">From Date:</label>
            <input type="date" id="fromDate" (change)="onFromDateChange($event)" class="form-control" />
        </div>

        <!-- To Date -->
        <div class="col-auto d-flex align-items-center">
            <label for="toDate" class="form-label me-2 text-nowrap">To Date:</label>
            <input type="date" id="toDate" (change)="onToDateChange($event)" class="form-control" />
        </div>
    </div>

    <div class="table-responsive mt-2">
        <table class="table table-striped table-bordered text-center mb-0">
            <thead class="table-light">
                <tr>
                    <th>Order ID</th>
                    <th>City</th>
                    <th>Scheduled Start Date</th>
                    <th>Scheduled End Date</th>
                    <th>Sar Received From Requester</th>
                    <th>Sar Allocted From Dumpster</th>
                    <th>Sar Allocted From Dumpyard</th>
                    <th>Sar Allocted To Smart-sort</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let order of orderSummaryData">
                    <td>{{ order.orderId }}</td>
                    <td>{{ order.city }}</td>
                    <td>{{ order.scheduleStartDate | date : "dd MMM yyyy" }}</td>
                    <td>{{ order.scheduleEndtDate | date : "dd MMM yyyy"}}</td>
                    <td>{{ order.sarReceivedFromRequester | date : "dd MMM yyyy"}}</td>
                    <td>{{ order.sarAllocatedToDumpster }}</td>
                    <td>{{ order.sarAllocatedToDumpyard }}</td>
                    <td>{{ order.sarAllocatedToSmartsort }}</td>
                </tr>
                <tr *ngIf="orderSummaryData?.length == 0">
                    <td colspan="8" class="text-center">No Data Found</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>